/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WorkingHoursInterval } from './workingHoursInterval';
import { WeekDayEnum } from './weekDayEnum';


export interface WorkingHoursCreateApiModel { 
    weekday: WeekDayEnum;
    intervals: Array<WorkingHoursInterval>;
}
export namespace WorkingHoursCreateApiModel {
}


